var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersPlusSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21612_120035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7638 17.5V12.5M14.2638 15H19.2638M10.9305 12.5H7.59717C6.04403 12.5 5.26746 12.5 4.65489 12.7537C3.83813 13.092 3.18922 13.741 2.8509 14.5577C2.59717 15.1703 2.59717 15.9469 2.59717 17.5M13.8472 2.7423C15.0688 3.23679 15.9305 4.43443 15.9305 5.83333C15.9305 7.23224 15.0688 8.42988 13.8472 8.92437M12.1805 5.83333C12.1805 7.67428 10.6881 9.16667 8.84717 9.16667C7.00622 9.16667 5.51383 7.67428 5.51383 5.83333C5.51383 3.99238 7.00622 2.5 8.84717 2.5C10.6881 2.5 12.1805 3.99238 12.1805 5.83333Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21612_120035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.930664)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersPlusSvg);
export default __webpack_public_path__ + "static/media/UsersPlusSvg.d940453409f5cb6e79b62293cbc40d48.svg";
export { ForwardRef as ReactComponent };